/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyletypohint4Inputs */

const en_aiflowstyletypohint4 = /** @type {(inputs: Aiflowstyletypohint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type as the image`)
};

const de_aiflowstyletypohint4 = /** @type {(inputs: Aiflowstyletypohint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrift als Bild`)
};

/**
* | output |
* | --- |
* | "Type as the image" |
*
* @param {Aiflowstyletypohint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyletypohint4 = /** @type {((inputs?: Aiflowstyletypohint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyletypohint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyletypohint4(inputs)
	return de_aiflowstyletypohint4(inputs)
});
export { aiflowstyletypohint4 as "aiFlowStyleTypoHint" }